export const DEFAULT_ANIM_DURATION = '8000'
